"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recipient = exports.PROMO_MARKER = void 0;
const with_class_name_1 = require("./with-class-name");
const _ = __importStar(require("lodash"));
exports.PROMO_MARKER = '<@promo_url>';
class Recipient extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.to = '';
        this.body = '';
    }
    addPromoMarker() {
        if (this.body && !_.includes(this.body, exports.PROMO_MARKER)) {
            this.body = `${this.body} ${exports.PROMO_MARKER}`;
        }
    }
}
exports.Recipient = Recipient;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/recipient.js
// module id = 1262
// module chunks = 0